module.exports = require('./watermark')



// WEBPACK FOOTER //
// ./src/plugins/watermark/index.js